import React, { useState } from 'react';
import { 
    Box, 
    Typography, 
    useTheme, 
    Tabs, 
    Tab, 
    Button, 
    Select, 
    MenuItem,
    ToggleButton,
    ToggleButtonGroup 
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import HistoryIcon from '@mui/icons-material/History';
import { tokens } from "../../theme";

const DashboardLayout = ({ 
    children, 
    currentTab, 
    onTabChange, 
    timeRange, 
    onTimeRangeChange,
    planFilter,
    onPlanFilterChange,
    onExportClick
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box px={3} py={2}>
            {/* Header / Title */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box>
                    <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
                        Dashboard
                    </Typography>
                </Box>

                <Box display="flex" gap={2} alignItems="center">
                    {/* Time Range Selector */}
                    <Select
                        value={timeRange}
                        onChange={(e) => onTimeRangeChange(e.target.value)}
                        size="small"
                        sx={{ bgcolor: colors.primary[400], borderRadius: '8px', minWidth: 150 }}
                    >
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="7d">Last 7 Days</MenuItem>
                        <MenuItem value="30d">Last 30 Days</MenuItem>
                        <MenuItem value="12m">Last 12 Months</MenuItem>
                        <MenuItem value="custom" disabled>Custom (Todo)</MenuItem>
                    </Select>

                    {/* Export Emails Button */}
                    <Button 
                        variant="contained" 
                        startIcon={<DownloadIcon />}
                        onClick={onExportClick}
                        sx={{ bgcolor: colors.blueAccent[700], color: "white" }}
                    >
                        Export Emails
                    </Button>
                </Box>
            </Box>

            {/* Filters Row */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                {/* Tabs */}
                <Tabs 
                    value={currentTab} 
                    onChange={onTabChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{ 
                        bgcolor: colors.primary[400], 
                        borderRadius: '8px',
                        minHeight: 48
                    }}
                >
                    <Tab label="Executive" />
                    <Tab label="Engagement" />
                    <Tab label="Matching" />
                    <Tab label="Monetization" />
                    <Tab label="Retention" />
                </Tabs>

                {/* Segment Filters */}
                <Box display="flex" gap={2} alignItems="center">
                    <Typography variant="body2" color={colors.grey[300]}>Plan:</Typography>
                    <ToggleButtonGroup
                        value={planFilter}
                        exclusive
                        onChange={(e, val) => val && onPlanFilterChange(val)}
                        size="small"
                        color="secondary"
                    >
                        <ToggleButton value="all">All</ToggleButton>
                        <ToggleButton value="free">Free</ToggleButton>
                        <ToggleButton value="premium">Premium</ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </Box>

            {/* Content */}
            <Box>
                {children}
            </Box>
        </Box>
    );
};

export default DashboardLayout;
